// src/pages/ChangePassword.jsx

import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, message, Result } from "antd";
import {
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { useParams, useNavigate } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import apiPath from "../../constants/apiPath";

const { Title } = Typography;

const ChangePassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { request } = useRequest();
  const { token } = useParams();
  const onFinish = (values) => {
    const { newPassword, confirmPassword } = values;
    if (values.newPassword !== values.confirmPassword) {
      message.error("New password and confirm password do not match!");
      return;
    }
    setLoading(true);
    const payload = {};
    payload.password = newPassword;
    payload.confirm_password = confirmPassword;
    payload.token = token;
    request({
      url: `${apiPath.resetPassword}`,
      method: "POST",
      data: payload,
      onSuccess: (response) => {
        ShowToast(
          response.message || "Password changed successfully!",
          Severty.SUCCESS
        );
        setLoading(false);
        setIsSuccess(true);
      },
      onError: (error) => {
        ShowToast(
          error?.message || "Failed to change password.",
          Severty.ERROR
        );
        setLoading(false);
      },
    });
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f2f5",
      }}
    >
      {!isSuccess ? (
        <Card style={{ width: 400 }}>
          <Title level={3} style={{ textAlign: "center" }}>
            Set New Password
          </Title>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="New Password"
              name="newPassword"
              rules={[
                { required: true, message: "Please enter your new password!" },
              ]}
            >
              <Input.Password
                prefix={<LockKeyhole />}
                placeholder="New Password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item
              label="Confirm New Password"
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Please confirm your new password!",
                },
              ]}
            >
              <Input.Password
                prefix={<LockKeyhole />}
                placeholder="Confirm Password"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Change Password
              </Button>
            </Form.Item>
          </Form>
        </Card>
      ) : (
        <Result
          status="success"
          title="Password Changed Successfully!"
          subTitle="You can now log in with your new password."
          extra={[
            <Button key="close" onClick={() => navigate("/login")}>
              Sign In
            </Button>,
          ]}
        />
      )}
    </div>
  );
};

export default ChangePassword;
